const map = {
	"./aiEditor/en.json": [
		"./src/i18n/locales/aiEditor/en.json",
		[
			"locale-aiEditor-en-json"
		]
	],
	"./aiEditor/zh.json": [
		"./src/i18n/locales/aiEditor/zh.json",
		[
			"locale-aiEditor-zh-json"
		]
	],
	"./aiTool/en.json": [
		"./src/i18n/locales/aiTool/en.json",
		[
			"locale-aiTool-en-json"
		]
	],
	"./aiTool/zh.json": [
		"./src/i18n/locales/aiTool/zh.json",
		[
			"locale-aiTool-zh-json"
		]
	],
	"./asset/en.json": [
		"./src/i18n/locales/asset/en.json",
		[
			"locale-asset-en-json"
		]
	],
	"./asset/zh.json": [
		"./src/i18n/locales/asset/zh.json",
		[
			"locale-asset-zh-json"
		]
	],
	"./common/en.json": [
		"./src/i18n/locales/common/en.json",
		[
			"locale-common-en-json"
		]
	],
	"./common/zh.json": [
		"./src/i18n/locales/common/zh.json",
		[
			"locale-common-zh-json"
		]
	],
	"./errorPage/en.json": [
		"./src/i18n/locales/errorPage/en.json",
		[
			"locale-errorPage-en-json"
		]
	],
	"./errorPage/zh.json": [
		"./src/i18n/locales/errorPage/zh.json",
		[
			"locale-errorPage-zh-json"
		]
	],
	"./home/en.json": [
		"./src/i18n/locales/home/en.json",
		[
			"locale-home-en-json"
		]
	],
	"./home/zh.json": [
		"./src/i18n/locales/home/zh.json",
		[
			"locale-home-zh-json"
		]
	],
	"./logIn/en.json": [
		"./src/i18n/locales/logIn/en.json",
		[
			"locale-logIn-en-json"
		]
	],
	"./logIn/zh.json": [
		"./src/i18n/locales/logIn/zh.json",
		[
			"locale-logIn-zh-json"
		]
	],
	"./menu/en.json": [
		"./src/i18n/locales/menu/en.json",
		[
			"locale-menu-en-json"
		]
	],
	"./menu/zh.json": [
		"./src/i18n/locales/menu/zh.json",
		[
			"locale-menu-zh-json"
		]
	],
	"./register/en.json": [
		"./src/i18n/locales/register/en.json",
		[
			"locale-register-en-json"
		]
	],
	"./register/zh.json": [
		"./src/i18n/locales/register/zh.json",
		[
			"locale-register-zh-json"
		]
	],
	"./subscription/en.json": [
		"./src/i18n/locales/subscription/en.json",
		[
			"locale-subscription-en-json"
		]
	],
	"./subscription/zh.json": [
		"./src/i18n/locales/subscription/zh.json",
		[
			"locale-subscription-zh-json"
		]
	],
	"./userSettings/en.json": [
		"./src/i18n/locales/userSettings/en.json",
		[
			"locale-userSettings-en-json"
		]
	],
	"./userSettings/zh.json": [
		"./src/i18n/locales/userSettings/zh.json",
		[
			"locale-userSettings-zh-json"
		]
	],
	"./wallet/en.json": [
		"./src/i18n/locales/wallet/en.json",
		[
			"locale-wallet-en-json"
		]
	],
	"./wallet/zh.json": [
		"./src/i18n/locales/wallet/zh.json",
		[
			"locale-wallet-zh-json"
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 7 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/i18n/locales lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;